import { useEffect, useState } from "react";

function useFetchData(fetchingMethod, fetch) {
    const [data, setData] = useState(undefined);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchData = async () => {
        setIsLoading(true);
        fetchingMethod()
            .then(({ data }) => {
                setData(data);
                setError(null);
            })
            .catch((err) => {
                setError(err.message);
                setData(undefined);
            })
            .finally(() => setIsLoading(false));
    };

    useEffect(() => {
        if (fetch) {
            fetchData();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fetchingMethod, fetch]);

    return { data, isLoading, error, fetchData };
}

export default useFetchData;